import { sendToURL, RoutePushDispatch, RouteAddIndexRouteDispatch } from './Actions/ReduxRouterActions'
import { ShowCustomDispatch, ShowErrorDispatch, ShowWarningDispatch, ShowSuccessDispatch,
  ShowInfoDispatch, ShowLoadingDispatch, ClearLoadingDispatch, ShowConfirmDispatch } from './Actions/ShowNotificationActions'
import { ClearValueDispatch, SetValueDispatch, UpdateArrayValueDispatch, AppendArrayValueDispatch } from './Actions/AppStateActions'
import { SetUserDispatch, ClearUserDispatch, SetSettingsDispatch, ClearSettingsDispatch, SetAccountDispatch, ClearAccountDispatch, UpdateAccountDispatch } from './Actions/CurrentSessionActions'
import { formCheckForSubmissionErrors, formInitValues, formResetValues, formSubmit, formDestroy, formRegisterField, formSetFieldValue,
  formUnregisterField, formRegisterFieldArray, formClearValidation, formSetErrors, formSetValidation,
  formShowSubmissionErrors, formStopSubmit, formResetFieldStates, formSetValidationFailed, formThrowSubissionError, formGetSubmissionErrors, formClearValidationFields, formSetValidationFields } from './Actions/ReduxFormActions'
import _ from 'common-tools/LodashHelper'
import { OpenDrawerDispatch, CloseDrawerDispatch } from './Actions/DrawerActions'
import { SetLayoutContentSearchDispatch, ClearLayoutContentSearchDispatch, SetLayoutContentMenusDispatch, ClearLayoutContentMenusDispatch,
  AddLayoutContentMenuDispatch, RemoveLayoutContentMenuDispatch, AddLayoutContentBreadCrumbKeyDispatch, ClearLayoutContentBreadCrumbKeysDispatch,
  SetLayoutContentMenusLoadingDispatch } from './Actions/LayoutContentActions'

const helperFunctions = {
  // router
  sendToURL,
  routePush: RoutePushDispatch,
  routeAddIndexRoute: RouteAddIndexRouteDispatch,

  // form
  formInitValues,
  formResetValues,
  formCheckForSubmissionErrors,
  formSubmit,
  formDestroy,
  formRegisterField,
  formUnregisterField,
  formSetFieldValue,
  formRegisterFieldArray,
  formClearValidation,
  formSetErrors,
  formSetValidation,
  formShowSubmissionErrors,
  formStopSubmit,
  formResetFieldStates,
  formSetValidationFailed,
  formThrowSubissionError,
  formGetSubmissionErrors,
  formClearValidationFields,
  formSetValidationFields,

  // message
  showCustom: ShowCustomDispatch,
  showError: ShowErrorDispatch,
  showSuccess: ShowSuccessDispatch,
  showWarning: ShowWarningDispatch,
  showInfo: ShowInfoDispatch,
  showLoading: ShowLoadingDispatch,
  clearLoading: ClearLoadingDispatch,
  showConfirm: ShowConfirmDispatch,

  // app state
  clearAppState: ClearValueDispatch,
  setAppState: SetValueDispatch,
  updateAppStateArray: UpdateArrayValueDispatch,
  appendAppStateArray: AppendArrayValueDispatch,

  // current session
  setUser: SetUserDispatch,
  clearUser: ClearUserDispatch,
  setSettings: SetSettingsDispatch,
  clearSettings: ClearSettingsDispatch,
  setAccount: SetAccountDispatch,
  clearAccount: ClearAccountDispatch,
  updateAccount: UpdateAccountDispatch,

  // drawer
  openDrawer: OpenDrawerDispatch,
  closeDrawer: CloseDrawerDispatch,

  // layout content
  setLayoutContentSearch: SetLayoutContentSearchDispatch,
  clearLayoutContentSearch: ClearLayoutContentSearchDispatch,
  setLayoutContentMenus: SetLayoutContentMenusDispatch,
  clearLayoutContentMenus: ClearLayoutContentMenusDispatch,
  addLayoutContentMenu: AddLayoutContentMenuDispatch,
  removeLayoutContentMenu: RemoveLayoutContentMenuDispatch,
  addLayoutContentBreadCrumbKey: AddLayoutContentBreadCrumbKeyDispatch,
  clearLayoutContentBreadCrumbKeys: ClearLayoutContentBreadCrumbKeysDispatch,
  setLayoutContentMenusLoading: SetLayoutContentMenusLoadingDispatch
}

export const ah = {
  // router
  sendToURL: 'sendToURL',
  routePush: 'routePush',
  routeAddIndexRoute: 'routeAddIndexRoute',

  // form
  formCheckForSubmissionErrors: 'formCheckForSubmissionErrors',
  formInitValues: 'formInitValues',
  formResetValues: 'formResetValues',
  formSubmit: 'formSubmit',
  formDestroy: 'formDestroy',
  formRegisterField: 'formRegisterField',
  formUnregisterField: 'formUnregisterField',
  formSetFieldValue: 'formSetFieldValue',
  formRegisterFieldArray: 'formRegisterFieldArray',
  formClearValidation: 'formClearValidation',
  formSetErrors: 'formSetErrors',
  formSetValidation: 'formSetValidation',
  formShowSubmissionErrors: 'formShowSubmissionErrors',
  formStopSubmit: 'formStopSubmit',
  formResetFieldStates: 'formResetFieldStates',
  formSetValidationFailed: 'formSetValidationFailed',
  formThrowSubissionError: 'formThrowSubissionError',
  formGetSubmissionErrors: 'formGetSubmissionErrors',
  formClearValidationFields: 'formClearValidationFields',
  formSetValidationFields: 'formSetValidationFields',

  // message
  showError: 'showError',
  showWarning: 'showWarning',
  showSuccess: 'showSuccess',
  showCustom: 'showCustom',
  showInfo: 'showInfo',
  showLoading: 'showLoading',
  clearLoading: 'clearLoading',
  showConfirm: 'showConfirm',

  // app state
  clearAppState: 'clearAppState',
  setAppState: 'setAppState',
  updateAppStateArray: 'updateAppStateArray',
  appendAppStateArray: 'appendAppStateArray',

  // current session
  setUser: 'setUser',
  clearUser: 'clearUser',
  setSettings: 'setSettings',
  clearSettings: 'clearSettings',
  setAccount: 'setAccount',
  clearAccount: 'clearAccount',
  updateAccount: 'updateAccount',

  // drawer
  openDrawer: 'openDrawer',
  closeDrawer: 'closeDrawer',

  // open content nav
  setLayoutContentSearch: 'setLayoutContentSearch',
  clearLayoutContentSearch: 'clearLayoutContentSearch',
  setLayoutContentMenus: 'setLayoutContentMenus',
  clearLayoutContentMenus: 'clearLayoutContentMenus',
  addLayoutContentMenu: 'addLayoutContentMenu',
  removeLayoutContentMenu: 'removeLayoutContentMenu',
  addLayoutContentBreadCrumbKey: 'addLayoutContentBreadCrumbKey',
  clearLayouContentBreadCrumbKeys: 'clearLayoutContentBreadCrumbKeys',
  setLayoutContentMenusLoading: 'setLayoutContentMenusLoading'
}

export const buildActions = (helpers) => {
  return (dispatch) => {
    let ret = {}
    _.forEach(helpers, (h) => {
      try {
        ret[h] = helperFunctions[h](dispatch)
      } catch (err) {
        ShowErrorDispatch()(`Error setting action helper function "${h}"`)
      }
    })
    return ret
  }
}

export default ah
